/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React  from 'react';
// material
import { Button, Tip } from '@insticator/insticator-ui';
import Space from 'material/space/space';
// content
// styles
import injectSheet from 'react-jss'
import styles from './actionbuttons_styles'


/* ========== ~~~~~~~~~~ MODERATION CONFIG V2: GENERAL SECTION ~~~~~~~~~~ ========== */
const ActionButtons = injectSheet(styles)((props) => {
  const { isDraftChanged, discardChange } = props;

  return (
    <Space justifyContent={'flex-end'} alignItems={'center'} klass={`productgroupactions ${props.classes.productgroupactions}`}>
      <Button variant={'primary'} name={'cancel'} text={'Cancel'} handleClick={() => discardChange?.()} disabled={!isDraftChanged} />
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ActionButtons;